import { render } from "./CenteredContent.vue?vue&type=template&id=196c8913"
import script from "./CenteredContent.vue?vue&type=script&lang=js"
export * from "./CenteredContent.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__